// extracted by mini-css-extract-plugin
module.exports = {"tag":"Card_tag__1I_yx","contenTag":"Card_contenTag__1Jjtt","contentCard":"Card_contentCard__1vq2J"};